import { render, staticRenderFns } from "./suitch-camera-config-widget.vue?vue&type=template&id=7341f3aa&scoped=true&"
import script from "./suitch-camera-config-widget.vue?vue&type=script&lang=js&"
export * from "./suitch-camera-config-widget.vue?vue&type=script&lang=js&"
import style0 from "./suitch-camera-config-widget.vue?vue&type=style&index=0&id=7341f3aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7341f3aa",
  null
  
)

export default component.exports